export enum RouteNames {
  analytics = "analytics",
  analyticsReport = "analyticsReport",
  analyticsNamedReport = "analyticsNamedReport",
  analyticsJustSavedReport = "analyticsJustSavedReport",
  campaigns = "campaigns",
  campaignsNew = "campaignsNew",
  campaignEdit = "campaignEdit",
  campaignCopy = "campaignCopy",
  campaignView = "campaignView",
  suggestedOptimisations = "suggestedOptimisations",
  lineitemNew = "lineitemNew",
  lineitemEdit = "lineitemEdit",
  lineitemCopy = "lineitemCopy",
  landingNew = "landingNew",
  landingEdit = "landingEdit",
  landingCopy = "landingCopy",
  audiences = "audiences",
  audienceNew = "audienceNew",
  creatives = "creatives",
  creativeEditRedesign = "creativeEditRedesign",
  traffic = "traffic",
  billing = "billing",
  billingNoTab = "billingNoTab",
  users = "users",
  userNew = "userNew",
  userEdit = "userEdit",
  organization = "organization",
  adminSettings = "adminSettings",
  testReporterQuery = "testReporterQuery",
  notFound = "notFound",
  appIntelligence = "appIntelligence",
  datetimePickerTest = "datetimePickerTest",
}
